import { GetShippingProfilesResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { shippingProfileBackupKeys } from "../queryKeys";

const getShippingProfileBackups = async (experienceId: string) => {
  const resp = await api.get<GetShippingProfilesResponseBodyType>(
    `/v2/experiences/${experienceId}/shipping-profiles`
  );
  return resp.data;
};

export const useGetShippingProfileBackups = (
  experienceId: string,
  options?: QueryOptions<GetShippingProfilesResponseBodyType, Error>
) => {
  return useQuery({
    ...options,
    queryKey: shippingProfileBackupKeys.selected(experienceId),
    queryFn: async () => getShippingProfileBackups(experienceId),
    enabled: Boolean(experienceId),
  });
};
